import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-modal-content" }
const _hoisted_2 = { class: "confirm-modal-content__header" }
const _hoisted_3 = {
  key: 0,
  class: "confirm-modal-content__main-content"
}
const _hoisted_4 = { class: "confirm-modal-content__footer footer" }

import Modal from '@/components/modal/Modal.vue';
import TextButton from '@/components/input/Btn/TextButton.vue';

// props

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmModal',
  props: {
    modalState: { type: Boolean, default: false },
    titleText: {},
    confirmButtonText: {},
    denyButtonText: {},
    contentText: { default: undefined }
  },
  emits: ["closeModal", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    class: "confirm-modal-container",
    "modal-size": 550,
    "stretch-container": true,
    "scroll-off": true,
    padding: '24px 16px',
    "modal-state": _ctx.modalState,
    "border-radius": '16px',
    onOutsideClick: _cache[0] || (_cache[0] = ($event: any) => (emits('closeModal')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, _toDisplayString(_ctx.titleText), 1)
        ]),
        (_ctx.contentText)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.contentText), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(TextButton, {
            "button-style": 'btn-cancel',
            size: 'btn-md',
            "on-click": () => emits('closeModal'),
            class: "footer__button footer__button--cancel"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.denyButtonText), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"]),
          _createVNode(TextButton, {
            "button-style": 'btn-primary',
            size: 'btn-md',
            "on-click": () => emits('confirm'),
            class: "footer__button footer__button--confirm"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.confirmButtonText), 1)
            ], undefined, true),
            _: 1
          }, 8, ["on-click"])
        ])
      ])
    ], undefined, true),
    _: 1
  }, 8, ["modal-state"]))
}
}

})